import { GridColumnSettings } from '@/shared/types/grid';

export const hiddenColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  chooserName?: string;
}): GridColumnSettings<T> => {
  const { uid, field, chooserName } = options;

  return {
    uid: uid ?? field,
    field,
    visible: false,
    showInColumnChooser: false,
    chooserName,
  };
};
